export const domainKeys = {
  planner: {
    getDomainsMetadata: () => ['planner', 'domainsMetadata'] as const,
  },
} as const;
